// Plan wizard → menu hand-off (#1221). After a wizard submit the visitor lands
// on their service's published menu. The service → slug map lives once, in the
// Deno-side automation config, so the redirect, the email and the text can't
// point at different menus.
import { MENU_SLUG_BY_EVENT_TYPE, menuPhrase } from "../../supabase/functions/_shared/automations/sequences.ts";
import type { PlanService } from "@/lib/plan-wizard-schema";

export { MENU_SLUG_BY_EVENT_TYPE, menuPhrase };

/** `/menu/<slug>?from=plan&ref=<event number>`: the post-submit landing page. */
export function planMenuPath(service: PlanService, ref: string): string {
  const slug = MENU_SLUG_BY_EVENT_TYPE[service];
  return `/menu/${encodeURIComponent(slug)}?from=plan&ref=${encodeURIComponent(ref)}`;
}

/** First word of the name, capped so a pasted paragraph can't blow out the banner. */
export function firstNameOf(clientName: string | null | undefined): string {
  return (clientName ?? "").trim().split(/\s+/)[0]?.slice(0, 40) ?? "";
}
